<template>
  <div class="bg">
    <div class="header">
      <h1>全国PSVD患者的临床特征及预后研究</h1>
    </div>
    <div class="login-form-box">
      <div class="form-container">
        <h2>欢迎使用本系统</h2>
        <transition name="fade" mode="out-in">
          <LoginForm
            v-if="activeTab === 'login'"
            key="login"
            @switch-to-register="switchTab('register')"
          />
          <RegisterForm
            v-else
            key="register"
            @switch-to-login="switchTab('login')"
          />
        </transition>
      </div>
      <!-- <h2>欢迎使用本系统</h2> -->
      <!-- <el-form :model="form" size="large" label-position="left" label-width="70px">
        <el-form-item label="姓&nbsp;&nbsp;&nbsp;名">
          <el-input v-model="form.name" placeholder="请输入您的姓名" @keyup.enter="login"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="请输入您的手机号" @keyup.enter="login"></el-input>
        </el-form-item>
        <el-button type="primary" :disabled="loginBtnDisabled" @click="login"  style="width: 100%"
                   :auto-insert-space="true">登录
        </el-button>
      </el-form> -->
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
import { useRouter } from "vue-router";
import { reactive, computed } from "vue";
import { ElMessage } from "element-plus";
import LoginForm from "../components/LoginForm.vue";
import RegisterForm from "../components/RegisterForm.vue";
import { ref } from "vue";
import "../styles/common.scss";

const env = import.meta.env;
console.log(env)

const activeTab = ref("login");
const switchTab = (tab) => {
  activeTab.value = tab;
};

const form = reactive({
  name: "",
  mobile: "",
});

const loginBtnDisabled = computed(() => {
  return !form.name || !form.mobile;
});

const userStore = useUserStore();
const router = useRouter();

// 如果已经登录，直接跳转到患者列表页
// if (userStore.isLogin) {
//   router.push({ name: "patients" });
// }

const login = async () => {
  const res = await userStore.login(form.name, form.mobile);
  console.log(res, "登录成功");
  if (res) {
    router.push({ name: "patients" });
    ElMessage({
      message: "登录成功",
      type: "success",
    });
  } else {
    // 登录失败
    ElMessage({
      message: "登录失败，请检查姓名和手机号是否正确",
      type: "error",
    });
  }
};
</script>

<style scoped lang="scss">
.bg {
  height: 100vh;
  width: 100vw;
  background: #f5f5f5;
}

.header {
  background: #d84357;
  height: 40vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  color: #ffffff;

  h1 {
    text-align: center;
    font-size: 30px;
    bottom: 20vh;
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
  }
}

.login-form-box {
  padding: 30px 30px 40px 30px;
  border-radius: 10px;
  box-shadow: #a2a2a2 0px 0px 10px 0px;
  width: 70vw;
  max-width: 400px;
  background: #ffffff;
  position: absolute;
  top: 30vh;
  left: 0;
  right: 0;
  margin: 0 auto;

  h2 {
    margin: 0 0 40px 0;
    text-align: center;
  }

  button {
    margin-top: 20px;
  }
}
// 动画
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
